import React from 'react'
import {ExampleInstance} from "../ExampleInstance";
import {ExampleInfo} from "./ExampleInfo";

// STYLE ##########################################################

// COMPONENT ##########################################################

export const ExampleNoSlider = ({collectionInstance}) => {
	return (
			<>
				{/* info */}
				<ExampleInfo collectionInstance={collectionInstance} />
    
				{/* example instances */}
				{collectionInstance.examples.map((example, i) =>
            <ExampleInstance exampleInstance={example} key={i}/>)
        }
			</>
	);
}
